import { ModalRoute, ModalSwitch } from '@circlefin/modal-router'
import { AceSendOnchain } from '@features/accelerated-chain-expansion/modals'
import { SendOnchain } from '@features/blockchain/modals'
import { ApprovalRequired } from '@features/transfer/modals'
import { OnChainTransferProvider } from '@modals/blockchain'
import { blockchain } from '@services/sections/modal/blockchain/blockchain'
import { ThirdwebProvider } from '@shared/wallet/provider'

/**
 * Blockchain Router.
 */
export const BlockchainRouter: React.FC = () => {
  return (
    <ThirdwebProvider>
      <OnChainTransferProvider>
        {/* Send-On-Chain */}
        <ModalSwitch path={blockchain.sendOnchain.switch}>
          <ModalRoute
            content={<SendOnchain.TransferRecipient />}
            path={blockchain.sendOnchain.recipient}
          />
          <ModalRoute
            content={<SendOnchain.TransferAmount />}
            path={blockchain.sendOnchain.amount}
          />
          <ModalRoute
            content={<SendOnchain.ReviewTransferDetails />}
            path={blockchain.sendOnchain.review}
          />
          <ModalRoute
            content={<ApprovalRequired />}
            path={blockchain.sendOnchain.approvalRequired}
          />
        </ModalSwitch>

        {/* ACE Send-On-Chain */}
        <ModalRoute
          content={<AceSendOnchain.PendingApproval />}
          path={blockchain.aceSendOnchain.pendingApproval}
        />
        <ModalRoute
          content={<AceSendOnchain.Send />}
          path={blockchain.aceSendOnchain.send}
        />
        <ModalRoute
          content={<AceSendOnchain.Receive />}
          path={blockchain.aceSendOnchain.receive}
        />
        <ModalRoute
          content={<AceSendOnchain.Success />}
          path={blockchain.aceSendOnchain.success}
        />
        <ModalRoute
          content={<AceSendOnchain.Failure />}
          path={blockchain.aceSendOnchain.failure}
        />
      </OnChainTransferProvider>
    </ThirdwebProvider>
  )
}
